import { HttpClient, HttpEvent, HttpHeaders, HttpParams, HttpRequest } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { OKTA_AUTH } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';
import { EMPTY, Observable } from 'rxjs';
import { ServiceItem } from './serviceitem'; 


@Injectable({
  providedIn: 'root'
})
export abstract class BaseService<T extends ServiceItem> {
  apiUrl: string = '';
  protected apiKey: string = '';
  getEndpoint: string = '';
  removeEndpoint: string = '';
  saveEndpoint: string = '';

  constructor(public http: HttpClient, @Inject(OKTA_AUTH) private auth: OktaAuth) {

  }

  getAllItems(): Observable<T[]> {
    const token = this.getToken();
    return this.getAllItemsWithToken(token);
  }

  getAllItemsWithToken(token: string): Observable<T[]> {

    const url = this.apiUrl + this.getEndpoint;
    if (token != undefined) {
      return this.http.get<T[]>(url, this.getHttpOptions(token));
    }
    else {
      return EMPTY;
    }
  }

  remove(item: T): Observable<boolean> {
    const token = this.getToken();
    const url: string = this.apiUrl + this.removeEndpoint + '/' + item.id;

    if (token != undefined) {
      return this.http.delete<boolean>(url, this.getHttpOptions(token));
    }
    else {
      return EMPTY;
    }
  }

  save(item: T, isNew: boolean): Observable<boolean> {
    const token = this.getToken();
    const url: string = this.apiUrl + this.saveEndpoint;
    if (token != undefined) {
      if (isNew) {
        return this.http.post<boolean>(url, item, this.getHttpOptions(token));
      }
      else {
        return this.http.put<boolean>(url, item, this.getHttpOptions(token));
      }
    }
    else {
      return EMPTY;
    }
  }

  public getToken(): string {
    return this.auth.getAccessToken() ?? '';
  }

  public getHttpOptions(token: string): object {

    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token,
        'Ocp-Apim-Subscription-Key': this.apiKey
      })
    };

  }

  public getHttpOptionsWithParams(token: string, params: HttpParams): object {

    return {
      params: params,
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      })
    };

  }
  
  public getHttpOptionsFileTypeParams(token:string,url:string): Observable<HttpEvent<Blob>> {

    const options = {
      headers: new HttpHeaders({
        'Accept': 'application/zip',
        'Authorization': 'Bearer ' + token,
        'Access-Control-Allow-Headers': 'origin,X-Requested-With,content-type,accept'
      }),
      responseType: 'blob' as 'json',
      reportProgress: true
    };

    const req = new HttpRequest('GET', url, null, options);
    return this.http.request(req);
  }
  public getHttpOptionsObjectTypeParams(token: string, url: string): Observable<any> {

    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      })
    };

    const req = new HttpRequest('GET', url, null, options);
    return this.http.request(req);
  }
  
}
